import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Loader } from '../../ui/loader';

import CustomContainer from '../../common/CustomContainer';
import { Article } from './Articles';

const DEFAULT_TIME_WINDOW_DROPDOWN_OPTIONS = [
  {
    key: '6 hours',
    text: '6 小時內',
    value: 0.25,
    content: '6 小時內',
  },
  {
    key: '12 hours',
    text: '12 小時內',
    value: 0.5,
    content: '12 小時內',
  },
  {
    key: 'today',
    text: '當日',
    value: 1,
    content: '當日',
  },
  {
    key: 'three days',
    text: '三日內',
    value: 3,
    content: '三日內',
  },
  {
    key: 'this week',
    text: '本週',
    value: 7,
    content: '本週',
  },
];

interface HotArticlesProps {
  isMobile: boolean;
  isFetching: boolean;
  data: any[];
  offset: number;
  total: number;
  pageSize: number;
  daysAgo: number;
  onPageChange: (e: any, data: any) => void;
  onChangeDaysAgoDropdown: (e: any, data: any) => void;
}

export default (props: HotArticlesProps) => {
  const {
    isMobile,
    isFetching,
    data,
    offset,
    total,
    pageSize,
    daysAgo,
    onPageChange,
    onChangeDaysAgoDropdown,
  } = props;

  const currentPage = Math.floor(offset / pageSize) + 1;

  return (
    <CustomContainer>
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className={isMobile ? 'text-xl' : 'text-2xl'}>
              熱門文章
            </CardTitle>
            <Select
              value={daysAgo.toString()}
              onValueChange={(value) => onChangeDaysAgoDropdown(null, { value: parseFloat(value) })}
            >
              <SelectTrigger className="w-32">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {DEFAULT_TIME_WINDOW_DROPDOWN_OPTIONS.map((option) => (
                  <SelectItem key={option.key} value={option.value.toString()}>
                    {option.text}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </CardHeader>
        <CardContent className="p-0">
          {isFetching ? (
            <div className="flex justify-center py-8">
              <Loader />
            </div>
          ) : (
            <>
              <div className="divide-y">
                {data.map((article) => (
                  <Article
                    key={article.id}
                    article={article}
                    isMobile={isMobile}
                    showAuthor
                    showBoard
                    showPushStats
                  />
                ))}
              </div>
              {total > 1 && (
                <div className="flex justify-center gap-1 p-4">
                  {Array.from({ length: total }, (_, i) => i + 1).map((page) => (
                    <Button
                      key={page}
                      variant={currentPage === page ? 'default' : 'outline'}
                      size="sm"
                      onClick={(e) => onPageChange(e, { activePage: page })}
                      className={isMobile && Math.abs(page - currentPage) > 1 ? 'hidden' : ''}
                    >
                      {page}
                    </Button>
                  ))}
                </div>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </CustomContainer>
  );
};